jQuery(document).ready(function () {
	// Store a reference to 'this' outside the setTimeout scope
	let category = "";
	let totalPages;
	paged = 1;
	pageClick = false;
	function loaderMore() {
		jQuery("#load-more-click").on("click", function (e) {
			totalPages = jQuery(this).data("total-pages");
			paged++;
			sendAjaxRequest(true);
			pageClick = true;
			if (paged == totalPages) {
				jQuery(this).hide();
			}
		});
	}
	loaderMore();
	jQuery("#categorySelect").on("change", function (e) {
		e.preventDefault();
		paged = 1;
		category = jQuery(this).val();
		console.log(category);
		sendAjaxRequest();
	});
	function loader() {
		jQuery(".loader-container").show();
	}
	function sendAjaxRequest(loadmore = false) {
		loader();
		jQuery.ajax({
			url: localVars.ajax_url,
			type: "POST",
			data: {
				action: "blog_filter",
				nonce: localVars.nonce,
				category,
				paged,
			},
			success(response) {
				if (response) {
					jQuery(".loader-container").hide();
					console.log(response.args);
					if (pageClick) {
						jQuery("#ajax-posts-container").append(response.html);
						loader();
						pageClick = false;
					} else {
						jQuery("#ajax-posts-container").html(response.html);
					}
					if (paged != totalPages) {
						jQuery("#load-more-container").html(
							response.pagination,
						);
						loaderMore();
					}

					jQuery(".loader-container").hide();
				}
			},
			error() {
				const htmlTag = jQuery(
					"<h2 class='center-align heading-5'>An error occurred while processing your request.😢</h2>",
				);
				jQuery("#ajax-post-container").html(htmlTag);
				jQuery(".loader-container").hide();
			},
		});
	}
});
